import { FallbackProps } from 'react-error-boundary';
import { Button } from './ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

const ErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => {
    console.error('Error caught:', error);

    document.body.style.backgroundColor = '#0f1923';

    return (
        <div style={{
            minHeight: '400px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#0f1923',
        }}>
            <div style={{ textAlign: 'center', maxWidth: '360px', padding: '2rem' }}>
                <div style={{
                    width: 64, height: 64, borderRadius: '50%',
                    background: '#1a2535', border: '1.5px solid #2d3f55',
                    display: 'flex', alignItems: 'center',
                    justifyContent: 'center', margin: '0 auto 1.5rem',
                }}>
                    <FontAwesomeIcon icon={faTriangleExclamation} size="2x" />
                </div>

                <h2 style={{ color: '#f9fafb', fontSize: 20, fontWeight: 600, margin: '0 0 8px' }}>
                    Something went wrong
                </h2>
                <p style={{ color: '#9ca3af', fontSize: 14, margin: '0 0 28px', lineHeight: 1.6 }}>
                    We encountered an unexpected error. Please try refreshing the page.
                </p>

                <Button
                    onClick={resetErrorBoundary}
                    style={{
                        background: '#2563eb', color: '#fff',
                        border: 'none', borderRadius: '50px',
                        padding: '10px 28px', fontSize: 14,
                        fontWeight: 500, cursor: 'pointer',
                    }}
                >
                    Refresh now
                    <FontAwesomeIcon icon={faRefresh} size="sm" className="ml-2" />
                </Button>
            </div>
        </div>
    );
};

export default ErrorFallback;